var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useShowScrollHint } from '../hooks';
import { Text } from '../text';
import { useModal } from './modal-context';
import { bodyShadowsStyle, bodyStaticStyle, bodyWrapperStaticStyle, } from './styles';
function Body(_a) {
    var { children } = _a, restProps = __rest(_a, ["children"]);
    const bodyRef = useRef(null);
    const { showEndHint: isShadowBottomVisible, showStartHint: isShadowTopVisible, } = useShowScrollHint(bodyRef, 'vertical');
    const { bodyId, id, setBodyId, size } = useModal();
    useEffect(() => {
        setBodyId(`${id}-body`);
    }, [id, setBodyId]);
    return (_jsxs("div", Object.assign({ css: bodyWrapperStaticStyle }, { children: [(isShadowTopVisible || isShadowBottomVisible) && (_jsx("div", { css: bodyShadowsStyle({
                    isShadowBottomVisible,
                    isShadowTopVisible,
                }) })), _jsx(Text, Object.assign({ as: "div", css: bodyStaticStyle, id: bodyId, ref: bodyRef }, Object.assign({ size }, restProps), { children: children }))] })));
}
export default Body;
